import axios from 'axios'
import authHeader from 'srcReact/helpers/auth-header'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const settingsService = {
  getUserDetails,
  putNames,
  putEmail,
  putPassword,
  putNumber,
  setEmailActivationCode,
  setEmailCodeValidation,
  setPasswordResetKey,
  toggleAllSettings,
  toggleAllGroupSettings,
  getGroupList,
  getDefaultNotificationSettings,
  getNotificationSettings,
  updateNotificationSettings,
  deactivateAccount,
  requestDeleteAccount
}

let cancel

//Account
function getUserDetails() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/user/settings/account`, requestOptions)
}

function putNames(payload) {
  if (cancel) {
    cancel()
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: payload,
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }
  return doRequestAxios(`/v2/user/settings/account/name/update`, requestOptions)
}

function putEmail(payload) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: payload
  }
  return doRequestAxios(`/v2/user/settings/account/email/update`, requestOptions)
}

function putPassword(payload) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: payload
  }
  return doRequestAxios(`/v2/user/settings/account/password/update`, requestOptions)
}

function putNumber(payload) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: payload
  }
  return doRequestAxios(`/v2/user/settings/account/phone/update`, requestOptions)
}

function setEmailActivationCode(payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/user/settings/send-activation-code`, requestOptions)
}

function setEmailCodeValidation(payload) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/user/settings/validate-activation-code`, requestOptions)
}

function setPasswordResetKey() {
  const requestOptions = {
    method: 'POST',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/user/settings/account/password/send-reset-link`, requestOptions)
}

//Notifications
function toggleAllSettings(payload) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/user/settings/notification/update-notification-all`, requestOptions)
}

function toggleAllGroupSettings(payload) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/user/settings/notification/update-notification-by-group`, requestOptions)
}

function getDefaultNotificationSettings(payload) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/user/settings/notification/get-settings`, requestOptions)
}

function getNotificationSettings(payload) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      type: payload.id_type,
      id_object: payload.group_id,
      role: payload.group_role,
      id_organization: payload.id_organization
    }
  }
  return doRequestAxios(`/v2/user/settings/notification/get-settings`, requestOptions)
}

function getGroupList(payload) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/user/groups/list`, requestOptions)
}

function updateNotificationSettings(view, params) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: {
      id_organization: params.id_organization,
      id_notification_setting: params.notification_id,
      id_object: view === 'group' ? params.group_id : params.id,
      type: params.type,
      value: params.value
    }
  }
  return doRequestAxios(`/v2/user/settings/notification/update-notification-setting`, requestOptions)
}

function deactivateAccount(orgId, groupTransferData) {
  const params = { id_organization: orgId }
  if (groupTransferData) {
    params.group_transfer_data = groupTransferData
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios(`/v2/user/deactivate`, requestOptions)
}

function requestDeleteAccount(orgId) {
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    params: {
      id_organization: orgId
    }
  }
  return doRequestAxios(`/v2/user/request-account-delete`, requestOptions)
}
